import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "../../../App";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLoggenInToken,
  getLoggedInUser,
} from "../../../store/selectors/AuthSelectors";
import { Button, Modal, Form, Table } from "react-bootstrap";
import { del, get, post } from "../../../services/api";
import SendEmail from "../Common/SendEmail";
// import { attendanceStatuses } from "../../constant/attendanceStatuses";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import moment from "moment";
import { Tab, Nav } from "react-bootstrap";
import { SVGICON } from "../../constant/theme";
import swal from "sweetalert";
import "./CandidateSearch.css";


const RequirementCandidates = ({
  showEditCandidateModal,
  setShowEditCandidateModal,
  selectedRequirement,
  token,
  weekRange,
  candidates,
  loggedInUser,
  attendanceStatusList,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [highlightedCandidateId, setHighlightedCandidateId] = useState(null);
  const [jobList, setJobList] = useState([]);
  const [selectedjobList, setselectedjobList] = useState([]);
  const [weeklyAttendance, setWeeklyAttendance] = useState([]);
  const [selectedCandidate, setSelectedCandidate] = useState([]);
  const [attendanceModal, setAttendanceModal] = useState(false);
  const [attendanceMultiModal, setAttendanceMultiModal] = useState(false);
  const [submitAttendanceModal, setSubmitAttendanceModal] = useState(false);
  const [attendanceDays, setAttendanceDays] = useState([]);
  const [currentCandidate, setCurrentCandidate] = useState(null);
  const [monthlyAttendance, setMonthlyAttendance] = useState([]);
  const [monthlyModal, setMonthlyModal] = useState(false);
  const emailComponentRef = useRef();
  const [attendanceStatus, setAttendanceStatus] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [overTimePayRate, setOverTimePayRate] = useState([]);
  const [bankHolidayOvertimePayRate, setBankHolidayOvertimePayRate] = useState([]);
  const [nightRatePayRate, setNightRatePayRate] = useState([]);
  const [storedAttendance, setStoredAttendance] = useState([]);
  const [localWeekRange, setLocalWeekRange] = useState(weekRange);  // Local state for weekRange
  const loadFromLocalStorage = () => {
    const storedData = localStorage.getItem("bulkAttendanceData");
    return storedData ? JSON.parse(storedData) : [];
  };
  useEffect(() => {
    setStoredAttendance(loadFromLocalStorage());
  }, []);
  const getCandidateName = (id) => {
    const candidate = candidates?.filter((itm) => itm?._id === id);
    return candidate?.length > 0
      ? candidate?.[0]?.firstName + " " + candidate?.[0]?.lastName
      : "--";
  };
  const handleCheckboxChange = (candidateId) => {
    setSelectedCandidates(
      (prevSelected) =>
        prevSelected.includes(candidateId)
          ? prevSelected.filter((id) => id !== candidateId) // Deselect
          : [...prevSelected, candidateId] // Select
    );
  };
  const openMarkAttendanceForSelected = () => {
    if (selectedCandidates.length === 0) {
      toast.error("Please select at least one candidate.");
      return;
    }
    const weekDaysInRange = getWeekDaysInRange(
      weekRange.startDate,
      weekRange.endDate
    );

    // Clear any previously stored attendance data
    localStorage.removeItem("bulkAttendanceData");

    // Map week days to their attendance status - start with blank entries
    const attendanceDays = weekDaysInRange.map((date) => {
      const utcDate = new Date(date); // Convert to UTC date
      const formattedDate = utcDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      return {
        day: utcDate.toLocaleDateString("en-GB", {
          weekday: "long",
          timeZone: "UTC",
        }),
        date: formattedDate,
        status: "", // Start with empty status
        hours: 0,
        overTimeHours: 0,
        bankHolidayOverTimeHours: 0,
        nightRateHours: 0,
        candidatePayHours: 0
      };
    });

    setAttendanceDays(attendanceDays); // Set the attendance days with blank values
    setStoredAttendance([]);
    setAttendanceMultiModal(true); // Open the modal
  };
  const markAttendanceForSelected = async () => {
    try {
      console.log("selectedCandidates", selectedCandidates);
      const promises = selectedCandidates.map(async (candidateId) => {
        console.log("candidateId", candidateId);
        const candidate = jobList.find(
          (item) => item.candidateId === candidateId
        );
        if (!candidate) return;
        await markAttendanceForCandidate(candidate);
      });

      await Promise.all(promises);
      toast.success("Attendance marked successfully for selected candidates.");
      setAttendanceMultiModal(false);
      fetchWeeklyAttendance(); // Refresh attendance data
    } catch (error) {
      toast.error("Error marking attendance for selected candidates.");
      console.error("Error:", error);
    }
  };

  // Mark attendance for a single candidate
  const markAttendanceForCandidate = async (candidate) => {
    try {
      const promises = attendanceDays.map(
        async ({ day, date, status, hours, overTimeHours, bankHolidayOverTimeHours, nightRateHours, candidatePayHours}) => {

          console.log("status", status);
          if (!status) return;
          const payload = {
            jobId: selectedRequirement?._id,
            candidateId: candidate.candidateId,
            jobDay: day,
            jobDate: date,
            status,
            hours: hours || 0,
            overTimeHours: overTimeHours || 0,
            bankHolidayOverTimeHours: bankHolidayOverTimeHours || 0,
            nightRateHours: nightRateHours || 0,
            candidatePayHours: candidatePayHours || 0
          };
          return post("/api/timesheet/add", payload, token);
        }
      );
      await Promise.all(promises);
    } catch (error) {
      console.error("Error marking attendance for candidate:", error);
      throw error;
    }
  };
  const filteredJobList = jobList.filter((item) => {
    const candidateName = getCandidateName(item?.candidateId).toLowerCase();
    return candidateName.includes(searchQuery.toLowerCase());
  });

  // Helper functions for checking attendance status
  const hasAnyInvoiceGenerated = () => {
    return selectedCandidates.some(candidateId => {
      const candidate = jobList.find(item => item.candidateId === candidateId);
      return candidate && candidate.invoiceNo;
    });
  };

  const hasAllAttendanceMarked = () => {
    if (selectedCandidates.length === 0) return false;
    
    return selectedCandidates.every(candidateId => {
      const candidateAttendance = weeklyAttendance.filter(att => att.candidateId === candidateId);
      return candidateAttendance.length > 0;
    });
  };

  const hasAllAttendanceSubmitted = () => {
    if (selectedCandidates.length === 0) return false;
    
    return selectedCandidates.every(candidateId => {
      const candidateAttendance = weeklyAttendance.filter(att => att.candidateId === candidateId);
      return candidateAttendance.some(att => att.isSubmitted);
    });
  };
  
  const canMarkAttendance = (candidateId) => {
    const candidate = jobList.find(item => item.candidateId === candidateId);
    return !candidate?.invoiceNo; // Can mark attendance only if invoice is not generated
  };
  
  const canSubmitAttendance = () => {
    return hasAllAttendanceMarked() && !hasAllAttendanceSubmitted();
  };
  
  const shouldShowDownloadInvoice = (candidateId) => {
    const candidate = jobList.find(item => item.candidateId === candidateId);
    return candidate && candidate.invoiceNo;
  };
  const renderSearchInput = () => (
    <div className="mb-4">
      <input
        type="text"
        placeholder="Search by candidate name..."
        className="form-control"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
    </div>
  );
  useEffect(() => {
    console.log("selectedRequirement", selectedRequirement);
    if (selectedRequirement?._id) {
      getCandidateJobList();
      fetchWeeklyAttendance();
      const data = selectedRequirement?.payRates?.filter(itm => String(itm?.type).toLowerCase() === "overtime");
      setOverTimePayRate(data || []);
      const bankHolidayOverTimeData = selectedRequirement?.payRates?.filter(itm => String(itm?.type).replace(/ /g,'').toLowerCase() === "bankholidayovertime");
      setBankHolidayOvertimePayRate(bankHolidayOverTimeData || []);
      const nightRateData = selectedRequirement?.payRates?.filter(itm => {
        const type = String(itm?.type || '').toLowerCase().replace(/\s/g, '');
        return type === "nighthour" || type === "nighttime" || type === "nightrate";
      });
      setNightRatePayRate(nightRateData || []);
    }

    if (attendanceStatusList) {
      setAttendanceStatus(attendanceStatusList?.map((itm) => itm.value));
    }
  }, [selectedRequirement, attendanceStatusList]);

  const fetchWeeklyAttendance = async () => {
    try {
      const payload = {
        weekStartDate: weekRange.startDate,
        weekEndDate: weekRange.endDate,
        requirementId: selectedRequirement?._id,
      };

      const response = await post("/api/timesheet/get/weekly", payload, token);
      setWeeklyAttendance(response?.data?.data || []);
    } catch (error) {
      setWeeklyAttendance([]);
      console.error("Error fetching weekly attendance:", error);
      toast.error("Error fetching weekly attendance.");
    }
  };
  const fetchMonthlyAttendanceAPI = async (startDate, endDate) => {
    try {
      const payload = {
        weekStartDate: startDate,
        weekEndDate: endDate,
        requirementId: selectedRequirement?._id,
      };

      const response = await post("/api/timesheet/get/weekly", payload, token);
      return response?.data?.data || [];
    } catch (error) {
      toast.error("Error fetching attendance.");
      return [];
    }
  };

  const sendEmail = (itm) => {
    setSelectedCandidate([]); // Clear state first
    setTimeout(() => {
      setSelectedCandidate(
        candidates?.filter((c) => c?._id === itm?.candidateId)
      ); // Set new candidate
      emailComponentRef.current.showEmailModal();
    }, 0);
  };
  const fetchMonthlyAttendance = async (updatedCandidate) => {
    try {
      const firstDate = dayjs(weekRange.startDate)
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastDate = dayjs(weekRange.startDate)
        .endOf("month")
        .format("YYYY-MM-DD");

      const attendance = await fetchMonthlyAttendanceAPI(firstDate, lastDate);
      setMonthlyAttendance(
        attendance?.filter(
          (itm) => itm?.candidateId === updatedCandidate?.candidateId
        )
      );
      setMonthlyModal(true);
    } catch (error) {
      console.error("Error fetching monthly attendance:", error);
    }
  };

  const getPayRate = () => {
    return selectedRequirement?.payRates?.filter(itm => {
      const type = String(itm?.type || '').toLowerCase().replace(/\s/g, '');
      return type !== "overtime" && 
             type !== "bankholidayovertime" && 
             type !== "bankholiday" &&
             type !== "nighthour" && 
             type !== "nighttime" && 
             type !== "nightrate";
    }).reduce(
      (total, item) => total + parseFloat(item.payRate || 0),
      0
    );
  };

  const getChargeRateRate = () => {
    return selectedRequirement?.payRates?.filter(itm => {
      const type = String(itm?.type || '').toLowerCase().replace(/\s/g, '');
      return type !== "overtime" && 
             type !== "bankholidayovertime" && 
             type !== "bankholiday" &&
             type !== "nighthour" && 
             type !== "nighttime" && 
             type !== "nightrate";
    }).reduce(
      (total, item) => total + parseFloat(item.chargeRate || 0),
      0
    );
  };

  const getOverTimePayRate = () => {
    return selectedRequirement?.payRates?.filter(itm => String(itm?.type).toLowerCase() === "overtime").reduce(
      (total, item) => total + parseFloat(item.payRate || 0),
      0
    );
  };

  const getOverTimeChargeRateRate = () => {
    return selectedRequirement?.payRates?.filter(itm => String(itm?.type).toLowerCase() === "overtime").reduce(
      (total, item) => total + parseFloat(item.chargeRate || 0),
      0
    );
  };

  const getBankHolidayOvertimePayRate = () => {
    return selectedRequirement?.payRates?.filter(itm => String(itm?.type).replace(/ /g,'').toLowerCase() === "bankholidayovertime").reduce(
      (total, item) => total + parseFloat(item.payRate || 0),
      0
    );
  };

  const getBankHolidayOvertimeChargeRate = () => {
    return selectedRequirement?.payRates?.filter(itm => String(itm?.type).replace(/ /g,'').toLowerCase() === "bankholidayovertime").reduce(
      (total, item) => total + parseFloat(item.chargeRate || 0),
      0
    );
  };

  const getNightRatePayRate = () => {
    return selectedRequirement?.payRates?.filter(itm => {
      const type = String(itm?.type || '').toLowerCase().replace(/\s/g, '');
      return type === "nighthour" || type === "nighttime" || type === "nightrate";
    }).reduce(
      (total, item) => total + parseFloat(item.payRate || 0),
      0
    );
  };

  const getNightRateChargeRate = () => {
    return selectedRequirement?.payRates?.filter(itm => {
      const type = String(itm?.type || '').toLowerCase().replace(/\s/g, '');
      return type === "nighthour" || type === "nighttime" || type === "nightrate";
    }).reduce(
      (total, item) => total + parseFloat(item.chargeRate || 0),
      0
    );
  };

  const getCandidateJobList = async () => {
    const response = await get(
      `/api/job/candidate/job/${selectedRequirement?._id}?weekStartDate=${dayjs(weekRange.startDate).format('YYYY-MM-DD')}&weekEndDate=${dayjs(weekRange.endDate).format('YYYY-MM-DD')}`,
      token
    );
    
    // Optional: Remove duplicates on frontend as a fallback
    const uniqueJobList = response.filter((item, index, self) => 
      index === self.findIndex((t) => 
        t.candidateId === item.candidateId && 
        t.jobId === item.jobId
      )
    );
    
    setJobList(uniqueJobList);
  };

  const viewCandidateDetails = (candidate) => {
    const params = new URLSearchParams(location.search);
    if (weekRange?.startDate) {
        params.set("weekStart", dayjs(weekRange.startDate).format("YYYY-MM-DD"));
    }
    if (weekRange?.endDate) {
        params.set("weekEnd", dayjs(weekRange.endDate).format("YYYY-MM-DD"));
    }

    const returnPathWithParams = `${location.pathname}?${params.toString()}`;

    navigate(`/add-candidate?id=${candidate.candidateId}&mode=view`, {
      state: {
        returnPath: returnPathWithParams,
        openCandidatesModal: true,
        selectedRequirement: selectedRequirement
      }
    });
  };

  const openAttendanceModal = (candidate) => {
    setCurrentCandidate(candidate);

    const currentCandidateAttendanceStatusList = weeklyAttendance.filter(
      (att) => att.candidateId === candidate.candidateId
    );

    // Get all weekdays in the range
    const weekDaysInRange = getWeekDaysInRange(
      weekRange.startDate,
      weekRange.endDate
    );

    // Map week days to their attendance status
    const attendanceDays = weekDaysInRange.map((date) => {
      const utcDate = new Date(date); // Convert to UTC date
      const formattedDate = utcDate.toISOString().split("T")[0]; // Format as YYYY-MM-DD

      // Find matching attendance status
      const attendanceStatus = currentCandidateAttendanceStatusList.find(
        (currentDate) => currentDate.jobDate.split("T")[0] === formattedDate
      );

      return {
        day: utcDate.toLocaleDateString("en-GB", {
          weekday: "long",
          timeZone: "UTC", // Consistently use UTC
        }),
        date: formattedDate, // Keep consistent date format
        status: attendanceStatus ? attendanceStatus.status : "", // Default to empty if not found
        hours: attendanceStatus ? attendanceStatus.hours : 0,
        overTimeHours: attendanceStatus ? attendanceStatus.overTimeHours : 0,
        bankHolidayOverTimeHours: attendanceStatus ? attendanceStatus.bankHolidayOverTimeHours : 0,
        nightRateHours: attendanceStatus ? attendanceStatus.nightRateHours : 0,
        candidatePayHours: attendanceStatus ? attendanceStatus?.candidatePayHours : 0,
      };
    });

    setAttendanceDays(attendanceDays); // Set the attendance days
    setAttendanceModal(true); // Open modal
  };

  const markAttendance = async () => {
    try {
      const promises = attendanceDays.map(
        async ({ day, date, status, hours, overTimeHours, bankHolidayOverTimeHours, nightRateHours,candidatePayHours }) => {
          if (!status) return;
          const payload = {
            jobId: selectedRequirement?._id,
            candidateId: currentCandidate?.candidateId,
            jobDay: day,
            jobDate: date,
            status,
            hours: hours || 0,
            overTimeHours: overTimeHours || 0,
            bankHolidayOverTimeHours: bankHolidayOverTimeHours || 0,
            nightRateHours: nightRateHours || 0,
            candidatePayHours: candidatePayHours || 0,
          };
          return post("/api/timesheet/add", payload, token);
        }
      );
      await Promise.all(promises);
      fetchWeeklyAttendance(); // Refresh attendance after marking
      setAttendanceModal(false);
      toast.success("Attendance has been marked successfully.");
    } catch (error) {
      toast.error("Error while marking attendance. Please try again");
      console.error("Error marking attendance:", error);
    }
  };

  const handleStatusChange = (index, value, saveToLocal = false) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) => {
        if (idx === index) {
          const updatedDay = { ...day, status: value };
          // If status is not Present (e.g. "Select Status" or empty), clear/reset all hours
          if (value !== "Present") {
            updatedDay.hours = "";
            updatedDay.overTimeHours = "";
            updatedDay.bankHolidayOverTimeHours = "";
            updatedDay.nightRateHours = "";
            updatedDay.candidatePayHours = "";
          }
          return updatedDay;
        }
        return day;
      });
      
      if (saveToLocal) {
        saveToLocalStorage(updatedDays);
      }
  
      return updatedDays;
    });
  };
  

  const handleHoursChange = async (index, value, saveToLocal = false) => {
    // Update the attendance days with the new hours value
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) =>
        idx === index ? { ...day, hours: value } : day
      );
      if (saveToLocal) {
        saveToLocalStorage(updatedDays);
      }
      return updatedDays;
    });
    
    // Validate candidate hours if we have a current candidate
    if (currentCandidate) {
      await validateCandidateHoursForAttendance(index, value);
    }
  };

  const handleOverTimeHoursChange = async (index, value, saveToLocal = false) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) =>
        idx === index ? { ...day, overTimeHours: Number(value) || 0, } : day
      );
      if (saveToLocal) {
        saveToLocalStorage(updatedDays);
      }
      return updatedDays;
    });
    
    // Validate candidate hours if we have a current candidate
    if (currentCandidate) {
      await validateCandidateHoursForAttendance(index, value, 'overtime');
    }
  };

  const handleBankHolidayHoursChange = async (index, value, saveToLocal = false) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) =>
        idx === index ? { ...day, bankHolidayOverTimeHours: Number(value) || 0, } : day
      );
      if (saveToLocal) {
        saveToLocalStorage(updatedDays);
      }
      return updatedDays;
    });
    
    // Validate candidate hours if we have a current candidate
    if (currentCandidate) {
      await validateCandidateHoursForAttendance(index, value, 'bankHoliday');
    }
  };
  const handleCandidatePayHoursChange = async (index, value, saveToLocal = false) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) =>
        idx === index ? { ...day, candidatePayHours: Number(value) || 0, } : day
      );
      if (saveToLocal) {
        saveToLocalStorage(updatedDays);
      }
      return updatedDays;
    });
    
    // Validate candidate hours if we have a current candidate
    if (currentCandidate) {
      await validateCandidateHoursForAttendance(index, value, 'candidatePay');
    }
  };

  const handleNightRateHoursChange = async (index, value, saveToLocal = false) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = prevDays.map((day, idx) =>
        idx === index ? { ...day, nightRateHours: Number(value) || 0, } : day
      );
      if (saveToLocal) {
        saveToLocalStorage(updatedDays);
      }
      return updatedDays;
    });
    
    // Validate candidate hours if we have a current candidate
    if (currentCandidate) {
      await validateCandidateHoursForAttendance(index, value, 'nightRate');
    }
  };

  // Function to validate candidate hours for attendance entries
  // This is now just a stub function that does nothing
  // We've removed the validation modal check and API call as requested
  const validateCandidateHoursForAttendance = async (index, value, hourType = 'regular') => {
    // No validation is performed
    return;
  };
  
  // Calculate total hours from all attendance entries
  const calculateTotalHours = () => {
    let total = 0;
    
    // Sum up all hours from attendance days
    attendanceDays.forEach(day => {
      // Only count hours if status is Present
      if (String(day.status).toLowerCase() === "present") {
        total += Number(day.hours || 0);
        total += Number(day.overTimeHours || 0);
        total += Number(day.bankHolidayOverTimeHours || 0);
        total += Number(day.nightRateHours || 0);
      }
    });
    
    return total;
  };
  
  // Reset hours for an entry based on the hour type
  const resetHoursForEntry = (index, hourType) => {
    setAttendanceDays((prevDays) => {
      const updatedDays = [...prevDays];
      
      // Reset the specific hour type that was being edited
      if (hourType === 'regular') {
        updatedDays[index].hours = 0;
      } else if (hourType === 'overtime') {
        updatedDays[index].overTimeHours = 0;
      } else if (hourType === 'bankHoliday') {
        updatedDays[index].bankHolidayOverTimeHours = 0;
      } else if (hourType === 'nightRate') {
        updatedDays[index].nightRateHours = 0;
      } else if (hourType === 'candidatePay') {
        updatedDays[index].candidatePayHours = 0;
      }
      
      return updatedDays;
    });
  };
  
  const getWeekDaysInRange = (startDate, endDate) => {
    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= new Date(endDate)) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates;
  };
  const renderMonthlyView = () => {
    const firstDate = dayjs(weekRange.startDate).startOf("month");
    const lastDate = dayjs(weekRange.startDate).endOf("month");

    const daysInMonth = [];
    for (
      let date = firstDate;
      date.isBefore(lastDate) || date.isSame(lastDate);
      date = date.add(1, "day")
    ) {
      daysInMonth.push(date.format("YYYY-MM-DD"));
    }

    return daysInMonth.map((date) => {
      const dayName = dayjs(date).format("ddd");
      const dayEntry = monthlyAttendance?.find((att) =>
        dayjs(att.jobDate).isSame(date, "day")
      );

      return (
        <div key={date} className="text-center border p-2 col-md-1">
          <span>
            {dayName} {dayjs(date).format("DD")}
          </span>
          <br />
          {dayEntry ? (
  dayEntry.status === "Present" ? (
    <i className="fa fa-check text-success"></i>
  ) : dayEntry.status === "Absent" ? (
    <i className="fa fa-times text-danger"></i>
  ) : (
    <>
      <small>
        {dayEntry.status?.charAt(0) === "P" ? (
          <>
            <strong>P</strong> - {dayEntry.hours || "0"}h 
            {dayEntry.overTimeHours ? ` + ${dayEntry.overTimeHours}h OT` : ""}
          </>
        ) : (
          <strong>{dayEntry.status?.charAt(0) || "-"}</strong>
        )}
      </small>
      <br />
    </>
  )
) : (
  <small>-</small>
)}

        </div>
      );
    });
  };
  const openSubmitAttendanceModal = (candidate) => {
    setCurrentCandidate(candidate);
    const candidateAttendance = weeklyAttendance.filter(
      (att) => att.candidateId === candidate.candidateId
    );
    setAttendanceDays(candidateAttendance);
    setSubmitAttendanceModal(true);
  };
  const submitAttendance = async () => {
    try {
      const promises = attendanceDays.map(async (day) => {
        const payload = {
          jobId: selectedRequirement?._id,
          candidateId: currentCandidate?.candidateId,
          jobDay: day.jobDay,
          jobDate: day.jobDate,
          isSubmitted: true,
          status: day.status || "",
          hours: day.hours || 0,
          overTimeHours: day.overTimeHours || 0,
          bankHolidayOverTimeHours: day.bankHolidayOverTimeHours || 0,
          nightRateHours: day.nightRateHours || 0,
          candidatePayHours: day.candidatePayHours || 0,
        };
        return post("/api/timesheet/add", payload, token);
      });
      await Promise.all(promises);
      fetchWeeklyAttendance(); // Refresh the weekly attendance
      setSubmitAttendanceModal(false);
      toast.success("Attendance has been submitted and approved successfully.");
    } catch (error) {
      toast.error("Error while submitting attendance. Please try again.");
      console.error("Error submitting attendance:", error);
    }
  };
  const handleAttendanceChange = (index, field, value) => {
    setAttendanceDays((prevDays) =>
      prevDays.map((day, i) => (i === index ? { ...day, [field]: value } : day))
    );
  };
  const generateConsolidatedInvoice = async (selectedjobList) => {
    const response = await post(
      "/api/timesheet/consolidated-invoice",
      {
        selectedjobList,
        weekStartDate: weekRange.startDate,
        weekEndDate: weekRange.endDate,
        requirementId: selectedRequirement?._id,
      },
      token
    );
    const data = response.data;
    if (data && data.filedata) {
      const byteCharacters = atob(data.filedata);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = data.filename;
      downloadLink.click();
      URL.revokeObjectURL(url);
    }
    getCandidateJobList();
    fetchWeeklyAttendance();
  };

  const generateInvoice = async (item) => {
    const response = await post(
      "/api/timesheet/invoice",
      {
        ...item,
        weekStartDate: weekRange.startDate,
        weekEndDate: weekRange.endDate,
        requirementId: selectedRequirement?._id,
      },
      token
    );
    const data = response.data;
    if (data && data.filedata) {
      const byteCharacters = atob(data.filedata);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const blob = new Blob(byteArrays, {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });
      const downloadLink = document.createElement("a");
      const url = URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = data.filename;
      downloadLink.click();
      URL.revokeObjectURL(url);
    }
    getCandidateJobList();
    fetchWeeklyAttendance();
  };

  const saveToLocalStorage = (data) => {
    const filteredData = data.map(({ status, hours, overTimeHours, bankHolidayOverTimeHours, nightRateHours }) => ({
      status,
      hours,
      overTimeHours,
      bankHolidayOverTimeHours,
      nightRateHours
    }));
    localStorage.setItem("bulkAttendanceData", JSON.stringify(filteredData));
  };

  // Helper functions have been moved to the top of the file
const clearInvoice = async (item) => {
  console.log("selectedRequirement", selectedRequirement);
  // ${selectedRequirement?._id}
  const timesheets = weeklyAttendance?.filter(itm => itm?.invoiceNo === item?.invoiceNo);
  console.log("timesheets", timesheets);
  const jobCandidate = jobList.find(
    (item) => item.candidateId === item?.candidateId
  )
  console.log("jobCandidate", jobCandidate);
  swal({
    title: "Are you sure?",
    text: "Once deleted, you will not be able to recover this invoice data!",
    icon: "warning",
    buttons: true,
    confirmButtonText: "Delete",
    dangerMode: true,
  }).then(async (willDelete) => {
    if (willDelete) {
      const response = await del(
        `/api/timesheet/delete-multiple`,
        token,
        {ids: timesheets.map(timesheet => timesheet._id), jobId: jobCandidate?.jobId, invoiceNo: timesheets?.[0]?.invoiceNo}
      );
      console.log("response", response);
      toast.success(
        "Invoice deleted successully."
      );
      getCandidateJobList();
      fetchWeeklyAttendance();
    } else {
    }
  });
}

  useEffect(() => {
    if (location.state && location.state.highlightCandidateId) {
      setHighlightedCandidateId(location.state.highlightCandidateId);
      
      // Clear the highlight after 5 seconds
      const timer = setTimeout(() => {
        setHighlightedCandidateId(null);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [location]);

  const columns = [
    // ... other columns ...
    {
      header: 'Actions',
      accessor: 'actions',
      cell: (row) => renderCandidateActions(row.original)
    }
  ];

  const renderCandidateActions = (candidate) => {
    return (
      <div>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => {
            // Navigate to candidate details page
            // Replace with actual navigation logic
            console.log("Navigate to candidate details page");
          }}
        >
          Details
        </button>
      </div>
    );
  };

  return (
    <>
      <Modal
        className="fade bd-example-modal-lg"
        show={showEditCandidateModal}
        size="xl"
        onHide={() => setShowEditCandidateModal(false)}
      >
        <Modal.Header>
          <Modal.Title>Candidates</Modal.Title>
          <Button
            variant=""
            className="btn-close"
            onClick={() => setShowEditCandidateModal(false)}
          ></Button>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="filter-section mb-3">
              <label className="me-3">
                Week:
                <input
                  type="date"
                  disabled
                  value={weekRange.startDate.toISOString().split("T")[0]}
                  className="form-control"
                />
              </label>
              <button
                className="btn btn-primary btn-sm"
                disabled={selectedjobList.length === 0}
                onClick={() => {
                  generateConsolidatedInvoice(selectedjobList);
                }}
              >
                Generate Consolidated Invoice
              </button>
              {renderSearchInput()}
            </div>
            <Tab.Container defaultActiveKey={"Grid"}>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h4 className="heading mb-0">&nbsp;</h4>
                <div className="d-flex align-items-center">
                  <Nav
                    as="ul"
                    className="nav nav-pills mix-chart-tab user-m-tabe"
                    id="pills-tab"
                  >
                    <Nav.Item as="li" className="nav-item" role="presentation">
                      <Nav.Link
                        as="button"
                        className="nav-link"
                        eventKey={"List"}
                      >
                        {SVGICON.List}
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li" className="nav-item">
                      <Nav.Link
                        as="button"
                        className="nav-link"
                        eventKey={"Grid"}
                      >
                        {SVGICON.GridDots}
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
              </div>
            </div>
            <div className="col-xl-12 active-p">
              <Tab.Content>
                <Tab.Pane eventKey={"Grid"}>
                  {filteredJobList && filteredJobList.length > 0 ? (
                    <div className="row">
                      {filteredJobList.map((item, index) => (
                        <div className="col-xl-4 col-lg-4 col-sm-6" key={index}>
                          <div className="card">
                            <div className="card-body">
                              <div className="card-use-box">
                                {item?.invoiceNo ? (
                                  <>{item?.invoiceNo}&nbsp;<button className="btn btn-sm btn-danger" onClick={() => clearInvoice(item)}><i className="fa fa-trash text-trash"></i> Invoice</button></>
                                ) : (
                                  <input
                                    type="checkbox"
                                    disabled={
                                      !(Array.isArray(weeklyAttendance)
                                        ? weeklyAttendance.find(
                                            (itm) =>
                                              itm?.candidateId ==
                                                item?.candidateId &&
                                              itm?.isSubmitted
                                          )
                                        : false)
                                    }
                                    onChange={() => {
                                      let updateList = [...selectedjobList];
                                      const exists = selectedjobList.find(
                                        (i) =>
                                          i.candidateId === item?.candidateId
                                      );
                                      if (exists) {
                                        updateList = selectedjobList.filter(
                                          (i) =>
                                            i.candidateId !== item?.candidateId
                                        );
                                      } else {
                                        updateList.push(item);
                                      }
                                      setselectedjobList(updateList);
                                    }}
                                  />
                                )}
                                <h4 className="mb-0">
                                  {getCandidateName(item?.candidateId)}
                                </h4>
                                <div className="d-flex justify-content-around">
                                  {Array.from({ length: 7 }).map((_, idx) => {
                                    const currentDate = new Date(
                                      weekRange.startDate
                                    );
                                    currentDate.setDate(
                                      currentDate.getDate() + idx
                                    );

                                    const formattedDate =
                                      dayjs(currentDate).format("YYYY-MM-DD");
                                    const dayName =
                                      dayjs(currentDate).format("ddd");
                                    const dayEntry = Array.isArray(
                                      weeklyAttendance
                                    )
                                      ? weeklyAttendance.find((entry) => {
                                          const entryDate = dayjs(
                                            entry.jobDate
                                          ).format("YYYY-MM-DD");
                                          return (
                                            entryDate === formattedDate &&
                                            entry?.candidateId ==
                                              item?.candidateId
                                          );
                                        })
                                      : null;
                                    const hasSubmittedEntry = Array.isArray(
                                      weeklyAttendance
                                    )
                                      ? weeklyAttendance.find(
                                          (itm) =>
                                            itm?.candidateId ==
                                              item?.candidateId &&
                                            itm?.isSubmitted
                                        )
                                      : false;
                                    const isAWR = item?.isAwr || false;
                                    if (idx === 0) {
                                      return (
                                        <React.Fragment
                                          key={`${formattedDate}-submitted`}
                                        >
                                          <div className="text-center">
                                            <span className="border d-block mb-1 p-1">
                                              AWR
                                            </span>
                                            {isAWR && (
                                              <i className="fa fa-check text-success"></i>
                                            )}
                                            {!isAWR && (
                                              <i className="fa fa-times text-danger"></i>
                                            )}
                                          </div>
                                          <div className="text-center">
                                            <span className="border d-block mb-1 p-1">
                                              Ts.
                                            </span>
                                            {hasSubmittedEntry && (
                                              <i className="fa fa-check text-success"></i>
                                            )}
                                            {!hasSubmittedEntry && (
                                              <i className="fa fa-times text-danger"></i>
                                            )}
                                          </div>
                                          <div
                                            key={formattedDate}
                                            className="text-center"
                                          >
                                            <span className="border d-block mb-1 p-1">
                                              {dayName.charAt(0)}
                                            </span>
                                            {dayEntry ? (
                                              dayEntry.status === "Present" ? (
                                                <i className="fa fa-check text-success"></i>
                                              ) : dayEntry.status ===
                                                "Absent" ? (
                                                <i className="fa fa-times text-danger"></i>
                                              ) : (
                                                <small>
                                                  {dayEntry.status?.charAt(0) ||
                                                    "-"}
                                                </small>
                                              )
                                            ) : (
                                              <small>-</small>
                                            )}
                                          </div>
                                        </React.Fragment>
                                      );
                                    }
                                    return (
                                      <div
                                        key={formattedDate}
                                        className="text-center"
                                      >
                                        <span className="border d-block mb-1 p-1">
                                          {dayName.charAt(0)}
                                        </span>
                                        {dayEntry ? (
                                          dayEntry.status === "Present" ? (
                                            <i className="fa fa-check text-success"></i>
                                          ) : dayEntry.status === "Absent" ? (
                                            <i className="fa fa-times text-danger"></i>
                                          ) : (
                                            <small>
                                              {dayEntry.status?.charAt(0) ||
                                                "-"}
                                            </small>
                                          )
                                        ) : (
                                          <small>-</small>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                                <div className="d-flex pt-2 flex-wrap justify-content-center align-items-center gap-2">
                                  
                                  <button
                                    className="btn btn-primary btn-sm"
                                    style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1' }}
                                    onClick={() => {
                                      if (
                                        selectedRequirement?.payRates
                                          ?.length === 0
                                      ) {
                                        toast.error(
                                          "Pay rates are not defined for this requirement. Please add pay rate to mark attendance."
                                        );
                                      } else {
                                        openAttendanceModal(item);
                                      }
                                    }}
                                    disabled={item?.invoiceNo}
                                  >
                                    Mark Attendance
                                  </button>
                                  <button
                                    className="btn btn-primary btn-sm"
                                    style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1' }}
                                    onClick={() => {
                                      if (
                                        selectedRequirement?.payRates
                                          ?.length === 0
                                      ) {
                                        toast.error(
                                          "Pay rates are not defined for this requirement. Please add pay rate to submit attendance."
                                        );
                                      } else {
                                        openSubmitAttendanceModal(item);
                                      }
                                    }}
                                  >
                                    {item?.invoiceNo
                                      ? "View Attendance"
                                      : "Submit Attendance"}
                                  </button>
                                  <button
                                    className="btn btn-primary btn-sm"
                                    style={{ backgroundColor: '#6f42c1', borderColor: '#6f42c1' }}
                                    disabled={
                                      !(Array.isArray(weeklyAttendance)
                                        ? weeklyAttendance.find(
                                            (itm) =>
                                              itm?.candidateId ==
                                                item?.candidateId &&
                                              itm?.isSubmitted
                                          )
                                        : false)
                                    }
                                    onClick={() => {
                                      if (
                                        weeklyAttendance.find(
                                          (itm) =>
                                            (itm?.candidateId ==
                                              item?.candidateId) &&
                                            itm?.isConsilatedInvoice
                                        )
                                      ) {
                                        generateConsolidatedInvoice(
                                          jobList.filter(
                                            (i) =>
                                              item?.invoiceNo === i?.invoiceNo
                                          )
                                        );
                                      } else {
                                        generateInvoice(item);
                                      }
                                    }}
                                  >
                                    <i className="fa fa-download text-white me-2" />
                                    {item?.invoiceNo
                                      ? weeklyAttendance.find(
                                        (itm) =>
                                          (itm?.candidateId ==
                                            item?.candidateId) &&
                                          itm?.isConsilatedInvoice
                                      ) ? "Consolidated Invoice" : "Invoice"
                                      : "Generate Invoice"}
                                  </button>
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => sendEmail(item)}
                                  >
                                    Send Email
                                  </button>
                                  <button
                                    className="btn btn-primary btn-sm"
                                    onClick={() => {
                                      const updatedCandidate = item;
                                      setCurrentCandidate(updatedCandidate);
                                      fetchMonthlyAttendance(updatedCandidate);
                                    }}
                                  >
                                    View Monthly Attendance
                                  </button>
                                  <button
                                    className="btn btn-info btn-sm"
                                    onClick={() => viewCandidateDetails(item)}
                                    title="View Candidate Details"
                                  >
                                    <i className="fa fa-eye"></i> Details
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                       ))}
                    </div>
                  ) : (
                    <div className="text-center p-5">
                      <h4>No candidates available</h4>
                      <p>There are no candidates to display for the selected week.</p>
                    </div>
                  )}
                </Tab.Pane>
                  <Tab.Pane eventKey={"List"}>
                    <div className="mb-4" style={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
                      <div>
                        <input
                          type="date"
                          className="form-control"
                          value={dayjs(localWeekRange.startDate).format("YYYY-MM-DD")}
                          onChange={(e) => {
                            const startDate = new Date(e.target.value);
                            const endDate = new Date(startDate);
                            endDate.setDate(startDate.getDate() + 6);
                            setLocalWeekRange({ startDate, endDate });
                          }}
                        />
                      </div>
                      {/* Consolidated invoice button removed as requested */}
                    </div>
                    {filteredJobList && filteredJobList.length > 0 ? (
                      <div>
                         <div className="mb-4" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                           <button
                             className="btn btn-primary btn-sm"
                             style={{
                               backgroundColor: '#6f42c1',
                               borderColor: '#6f42c1',
                               opacity: (selectedCandidates.length > 0 && selectedCandidates.some(id => canMarkAttendance(id))) ? 1 : 0.65,
                               cursor: (selectedCandidates.length > 0 && selectedCandidates.some(id => canMarkAttendance(id))) ? 'pointer' : 'not-allowed'
                             }}
                             onClick={() => {
                               if (selectedCandidates.length > 0) {
                                 // Filter out candidates that already have invoices
                                 const markableCandidates = selectedCandidates.filter(id => canMarkAttendance(id));
                                 
                                 if (markableCandidates.length === 0) {
                                   toast.warn("Selected candidates already have invoices generated");
                                 } else {
                                   // Set only markable candidates as selected before opening modal
                                   setSelectedCandidates(markableCandidates);
                                   openMarkAttendanceForSelected();
                                 }
                               } else {
                                 toast.warn("Please select at least one candidate");
                               }
                             }}
                             disabled={selectedCandidates.length === 0 || !selectedCandidates.some(id => canMarkAttendance(id))}
                           >
                             Mark Attendance
                           </button>
                           
                           <button
                             className="btn btn-primary btn-sm"
                             style={{
                               backgroundColor: '#6f42c1',
                               borderColor: '#6f42c1',
                               opacity: (selectedCandidates.length > 0 && (canSubmitAttendance() || hasAllAttendanceSubmitted())) ? 1 : 0.65,
                               cursor: (selectedCandidates.length > 0 && (canSubmitAttendance() || hasAllAttendanceSubmitted())) ? 'pointer' : 'not-allowed'
                             }}
                             onClick={() => {
                               if (selectedCandidates.length === 0) {
                                 toast.warn("Please select at least one candidate");
                                 return;
                               }
                               
                               if (!hasAllAttendanceMarked()) {
                                 toast.warn("Please mark attendance for all days before submitting");
                                 return;
                               }
                               
                               const selectedCandidate = filteredJobList.find(item => item.candidateId === selectedCandidates[0]);
                               if (selectedCandidate) {
                                 openSubmitAttendanceModal(selectedCandidate);
                               } else {
                                 toast.warn("Please select a valid candidate");
                               }
                             }}
                             disabled={selectedCandidates.length === 0 || !hasAllAttendanceMarked()}
                           >
                             {hasAllAttendanceSubmitted() ? "View Attendance" : "Submit Attendance"}
                           </button>
                           

                           
                           {/* Only show delete button for candidates with invoices */}
                            {hasAnyInvoiceGenerated() && (
                              <button
                                className="btn btn-danger btn-sm"
                                style={{
                                  opacity: selectedCandidates.length > 0 && selectedCandidates.every(id => shouldShowDownloadInvoice(id)) ? 1 : 0.65,
                                  cursor: selectedCandidates.length > 0 && selectedCandidates.every(id => shouldShowDownloadInvoice(id)) ? 'pointer' : 'not-allowed'
                                }}
                                onClick={() => {
                                  if (selectedCandidates.length === 0) {
                                    toast.warn("Please select at least one candidate");
                                    return;
                                  }
                                  
                                  // Check if all selected candidates have invoices
                                  if (!selectedCandidates.every(id => shouldShowDownloadInvoice(id))) {
                                    toast.warn("Can only delete candidates with generated invoices");
                                    return;
                                  }
                                  
                                  swal({
                                    title: "Are you sure?",
                                    text: "Once deleted, you will not be able to recover this invoice data!",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                  }).then((willDelete) => {
                                    if (willDelete) {
                                      // Implement delete functionality here
                                      const selectedInvoiceCandidates = selectedCandidates.filter(id => shouldShowDownloadInvoice(id));
                                      if (selectedInvoiceCandidates.length > 0) {
                                        // Call clearInvoice for each candidate with invoice
                                        selectedInvoiceCandidates.forEach(candidateId => {
                                          const candidate = filteredJobList.find(item => item.candidateId === candidateId);
                                          if (candidate) {
                                            clearInvoice(candidate);
                                          }
                                        });
                                        setSelectedCandidates([]);
                                      }
                                    }
                                  });
                                }}
                                disabled={selectedCandidates.length === 0 || !selectedCandidates.every(id => shouldShowDownloadInvoice(id))}
                              >
                                Delete Invoice
                              </button>
                            )}
                           

                           
                           <button
                             className="btn btn-primary btn-sm"
                             style={{
                               backgroundColor: '#6f42c1',
                               borderColor: '#6f42c1',
                               opacity: (selectedCandidates.length > 0) ? 1 : 0.65,
                               cursor: (selectedCandidates.length > 0) ? 'pointer' : 'not-allowed'
                             }}
                             onClick={() => {
                               if (selectedCandidates.length === 0) {
                                 toast.warn("Please select at least one candidate");
                                 return;
                               }
                               
                               // Check if any selected candidates have invoices already
                               const anyHaveInvoices = selectedCandidates.some(id => shouldShowDownloadInvoice(id));
                               
                               // For consolidated invoices (multiple selection), prevent if any have invoices
                               if (selectedCandidates.length > 1 && anyHaveInvoices) {
                                 toast.warn("Cannot generate consolidated invoice with candidates that already have invoices. Please select only candidates without invoices.");
                                 return;
                               }
                               
                               // For single invoice, if it already has an invoice, just download it
                               const hasInvoice = selectedCandidates.length === 1 && shouldShowDownloadInvoice(selectedCandidates[0]);
                               
                               // If no invoices exist yet, check if attendance is submitted
                               if (!anyHaveInvoices && !hasAllAttendanceSubmitted()) {
                                 toast.warn("Please submit attendance before generating invoice");
                                 return;
                               }
                               
                               if (selectedCandidates.length === 1) {
                                 const selectedCandidate = filteredJobList.find(item => item.candidateId === selectedCandidates[0]);
                                 if (selectedCandidate) {
                                   generateInvoice(selectedCandidate);
                                 } else {
                                   toast.warn("Please select a valid candidate");
                                 }
                               } else {
                                 const selectedJobList = filteredJobList.filter(item => 
                                   selectedCandidates.includes(item.candidateId)
                                 );
                                 generateConsolidatedInvoice(selectedJobList);
                               }
                             }}
                             disabled={selectedCandidates.length === 0}
                           >
                             <i className="fa fa-download text-white me-2" />
                             {hasAnyInvoiceGenerated() ? 
                               (selectedCandidates.length === 1 ? "Download Invoice" : "Download Consolidated Invoice") : 
                               (selectedCandidates.length === 1 ? "Generate Invoice" : "Generate Consolidated Invoice")}
                           </button>
                        </div>
                        <Table striped bordered hover responsive>
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    selectedCandidates.length ===
                                    filteredJobList.length
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedCandidates(
                                        filteredJobList.map(
                                          (item) => item.candidateId
                                        )
                                      );
                                    } else {
                                      setSelectedCandidates([]);
                                    }
                                  }}
                                />
                              </th>
                              <th>Ts.</th>
                              <th>Candidate Name</th>
                              <th/>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredJobList.map((item, index) => {
                          const candidateName = getCandidateName(
                            item?.candidateId
                          );
                          const hasSubmittedEntry = Array.isArray(
                            weeklyAttendance
                          )
                            ? weeklyAttendance.find(
                                (itm) =>
                                  itm?.candidateId === item?.candidateId &&
                                  itm?.isSubmitted
                              )
                            : false;

                          return (
                            <tr 
                              key={index} 
                              className={highlightedCandidateId === item.candidateId ? "highlight-candidate" : ""}
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  checked={selectedCandidates.includes(
                                    item.candidateId
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(item.candidateId)
                                  }
                                />
                              </td>
                              <td>
                                {hasSubmittedEntry ? (
                                  <i className="fa fa-check text-success"></i>
                                ) : (
                                  <i className="fa fa-times text-danger"></i>
                                )}
                              </td>
                              <td>{candidateName}</td>
                              <td>
                              <div className="d-flex justify-content-around">
                                  {Array.from({ length: 7 }).map((_, idx) => {
                                    const currentDate = new Date(
                                      weekRange.startDate
                                    );
                                    currentDate.setDate(
                                      currentDate.getDate() + idx
                                    );

                                    const formattedDate =
                                      dayjs(currentDate).format("YYYY-MM-DD");
                                    const dayName =
                                      dayjs(currentDate).format("ddd");
                                    const dayEntry = Array.isArray(
                                      weeklyAttendance
                                    )
                                      ? weeklyAttendance.find((entry) => {
                                          const entryDate = dayjs(
                                            entry.jobDate
                                          ).format("YYYY-MM-DD");
                                          return (
                                            entryDate === formattedDate &&
                                            entry?.candidateId ==
                                              item?.candidateId
                                          );
                                        })
                                      : null;
                                    const hasSubmittedEntry = Array.isArray(
                                      weeklyAttendance
                                    )
                                      ? weeklyAttendance.find(
                                          (itm) =>
                                            itm?.candidateId ==
                                              item?.candidateId &&
                                            itm?.isSubmitted
                                        )
                                      : false;
                                    const isAWR = item?.isAwr || false;
                                    if (idx === 0) {
                                      return (
                                        <React.Fragment
                                          key={`${formattedDate}-submitted`}
                                        >
                                          <div className="text-center">
                                            <span className="border d-block mb-1 p-1">
                                              AWR
                                            </span>
                                            {isAWR && (
                                              <i className="fa fa-check text-success"></i>
                                            )}
                                            {!isAWR && (
                                              <i className="fa fa-times text-danger"></i>
                                            )}
                                          </div>
                                          <div className="text-center">
                                            <span className="border d-block mb-1 p-1">
                                              Ts.
                                            </span>
                                            {hasSubmittedEntry && (
                                              <i className="fa fa-check text-success"></i>
                                            )}
                                            {!hasSubmittedEntry && (
                                              <i className="fa fa-times text-danger"></i>
                                            )}
                                          </div>
                                          <div
                                            key={formattedDate}
                                            className="text-center"
                                          >
                                            <span className="border d-block mb-1 p-1">
                                              {dayName.charAt(0)}
                                            </span>
                                            {dayEntry ? (
                                              dayEntry.status === "Present" ? (
                                                <i className="fa fa-check text-success"></i>
                                              ) : dayEntry.status ===
                                                "Absent" ? (
                                                <i className="fa fa-times text-danger"></i>
                                              ) : (
                                                <small>
                                                  {dayEntry.status?.charAt(0) ||
                                                    "-"}
                                                </small>
                                              )
                                            ) : (
                                              <small>-</small>
                                            )}
                                          </div>
                                        </React.Fragment>
                                      );
                                    }
                                    return (
                                      <div
                                        key={formattedDate}
                                        className="text-center"
                                      >
                                        <span className="border d-block mb-1 p-1">
                                          {dayName.charAt(0)}
                                        </span>
                                        {dayEntry ? (
                                          dayEntry.status === "Present" ? (
                                            <i className="fa fa-check text-success"></i>
                                          ) : dayEntry.status === "Absent" ? (
                                            <i className="fa fa-times text-danger"></i>
                                          ) : (
                                            <small>
                                              {dayEntry.status?.charAt(0) ||
                                                "-"}
                                            </small>
                                          )
                                        ) : (
                                          <small>-</small>
                                        )}
                                      </div>
                                    );
                                  })}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                    ) : (
                      <div className="text-center p-5">
                        <h4>No candidates available</h4>
                        <p>There are no candidates to display for the selected week.</p>
                      </div>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </Tab.Container>
          </div>
          <SendEmail
            ref={emailComponentRef}
            Title="Send Email"
            token={token}
            data={selectedCandidate}
            user={loggedInUser}
          />
        </Modal.Body>
      </Modal>
      {/* Attendance Modal */}
      <Modal
        show={attendanceMultiModal}
        onHide={() => setAttendanceMultiModal(false)}
        size="xl"
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Mark Attendance for Selected Candidates</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list-group">
            {attendanceDays.map((day, idx) => {
              console.log("day", day);
              const date = new Date(day?.date);
              const jobStartDate = new Date(selectedRequirement.jobStartDate);
              const jobEndDate = new Date(selectedRequirement.jobEndDate);
              if (isNaN(date.getTime())) {
                return null;
              }
              const dayName = date.toLocaleDateString("en-GB", {
                weekday: "long",
              });
              if (
                isNaN(date.getTime()) ||
                date < jobStartDate ||
                date > jobEndDate ||
                !selectedRequirement?.daysOfWork?.includes(
                  date.toLocaleDateString("en-GB", { weekday: "long" })
                )
              ) {
                return null;
              }
              return (
                <div
                  key={idx}
                  className="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                  style={{ gap: '10px' }}
                >
                  <div style={{ width: '150px' }}>
                    {dayName} ({date.toLocaleDateString("en-GB")})
                  </div>
                  <Form.Control
                    as="select"
                    value={day.status || ""}
                    onChange={(e) => handleStatusChange(idx, e.target.value, true)}
                    style={{ width: '130px' }}
                  >
                    <option value="">Select Status</option>
                    {attendanceStatus.map((status, statusIdx) => (
                      <option key={statusIdx} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Control>
                  
                  <Form.Control
                    type="number"
                    min="0"
                    disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                    placeholder="Normal Hours"
                    value={day.hours || ""}
                    onChange={(e) => handleHoursChange(idx, e.target.value, true)}
                    style={{ width: '130px' }}
                  />
                  
                  <Form.Control
                    type="number"
                    min="0"
                    disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                    placeholder="Overtime Hours"
                    value={day.overTimeHours || ""}
                    onChange={(e) =>
                      handleOverTimeHoursChange(idx, e.target.value, true)
                    }
                    style={{ width: '130px' }}
                  />
                  
                  <Form.Control
                    type="number"
                    min="0"
                    disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                    placeholder="Bank Holiday OT"
                    value={day.bankHolidayOverTimeHours || ""}
                    onChange={(e) =>
                      handleBankHolidayHoursChange(idx, e.target.value, true)
                    }
                    style={{ width: '130px' }}
                  />
                  
                  <Form.Control
                    type="number"
                    min="0"
                    disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                    placeholder="Night Hours"
                    value={day.nightRateHours || ""}
                    onChange={(e) =>
                      handleNightRateHoursChange(idx, e.target.value, true)
                    }
                    style={{ width: '130px' }}
                  />
                  
                  <Form.Control
                    type="number"
                    min="0"
                    disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                    placeholder="Candidate Pay hr"
                    value={day.candidatePayHours || ""}
                    onChange={(e) =>
                      handleCandidatePayHoursChange(idx, e.target.value, true)
                    }
                    style={{ width: '130px' }}
                  />
                </div>
              );
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setAttendanceMultiModal(false)}
          >
            Cancel
          </Button>
          <Button variant="primary" onClick={markAttendanceForSelected}>
            Save Attendance
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={attendanceModal}
        onHide={() => setAttendanceModal(false)}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Mark Attendance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list-group">
            {attendanceDays.map((day, idx) => {
              const date = new Date(day?.date);
              const jobStartDate = new Date(selectedRequirement.jobStartDate);
              const jobEndDate = new Date(selectedRequirement.jobEndDate);
              if (isNaN(date.getTime())) {
                return null;
              }
              const dayName = date.toLocaleDateString("en-GB", {
                weekday: "long",
              });
              if (
                isNaN(date.getTime()) ||
                date < jobStartDate ||
                date > jobEndDate ||
                !selectedRequirement?.daysOfWork?.includes(
                  date.toLocaleDateString("en-GB", { weekday: "long" })
                )
              ) {
                return null;
              }
              return (
                <div
                  key={idx}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div className="w-50">
                    {dayName} ({date.toLocaleDateString("en-GB")})
                  </div>
                  <Form.Control
                    as="select"
                    value={day.status}
                    onChange={(e) => handleStatusChange(idx, e.target.value)}
                  >
                    <option value="">Select Status</option>
                    {attendanceStatus.map((status, statusIdx) => (
                      <option key={statusIdx} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Control>
                  &nbsp;
                  <Form.Control
                    type="number"
                    min="0"
                    disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                    placeholder="Normal Hours"
                    value={day.hours || ""}
                    onChange={(e) => handleHoursChange(idx, e.target.value)}
                    className="w-35"
                  />
                  &nbsp;
                  {overTimePayRate?.length > 0 && (
                    <Form.Control
                      type="number"
                      min="0"
                      disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                      placeholder="Overtime Hours"
                      value={day.overTimeHours || ""}
                      onChange={(e) =>
                        handleOverTimeHoursChange(idx, e.target.value)
                      }
                      className="w-20"
                    />
                  )}
                  &nbsp;
                  {bankHolidayOvertimePayRate?.length > 0 && (
                    <Form.Control
                      type="number"
                      min="0"
                      disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                      placeholder="Bank Holiday OT"
                      value={day.bankHolidayOverTimeHours || ""}
                      onChange={(e) =>
                        handleBankHolidayHoursChange(idx, e.target.value)
                      }
                      className="w-20"
                    />
                  )}
                  &nbsp;
                  {nightRatePayRate?.length > 0 && (
                    <Form.Control
                      type="number"
                      min="0"
                      disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                      placeholder="Night Hours"
                      value={day.nightRateHours || ""}
                      onChange={(e) =>
                        handleNightRateHoursChange(idx, e.target.value)
                      }
                      className="w-20"
                    />
                  )}
                  <Form.Control
                      type="number"
                      min="0"
                      disabled={(String(day.status).toLowerCase() === "present" || day.status === "") ? false : true}
                      placeholder="Candidate Pay hour -"
                      value={day.candidatePayHours || ""}
                      onChange={(e) =>
                        handleCandidatePayHoursChange(idx, e.target.value, true)
                      }
                      className="w-20"
                    />
                </div>
              );
            })}
            {/* Totals Row */}
            {/* Totals Row */}
<div className="list-group-item d-flex justify-content-between gap-2 align-items-center font-weight-bold bg-light">
  {/* Day column */}
  <div className="w-25">Total Hours</div>

  {/* Status column - left empty */}
  <div className="w-132"></div>

  {/* Normal Hours */}
  <Form.Control
    disabled
    value={attendanceDays.reduce((sum, day) => sum + (parseFloat(day.hours) || 0), 0).toFixed(2)}
    className="w-20 bg-light"
  />

  {/* Overtime Hours */}
  {overTimePayRate?.length > 0 && (
    <Form.Control
      disabled
      value={attendanceDays.reduce((sum, day) => sum + (parseFloat(day.overTimeHours) || 0), 0).toFixed(2)}
      className="w-20 bg-light"
    />
  )}

  {/* Bank Holiday OT */}
  {bankHolidayOvertimePayRate?.length > 0 && (
    <Form.Control
      disabled
      value={attendanceDays.reduce((sum, day) => sum + (parseFloat(day.bankHolidayOverTimeHours) || 0), 0).toFixed(2)}
      className="w-20 bg-light"
    />
  )}

  {/* Night Hours */}
  {nightRatePayRate?.length > 0 && (
    <Form.Control
      disabled
      value={attendanceDays.reduce((sum, day) => sum + (parseFloat(day.nightRateHours) || 0), 0).toFixed(2)}
      className="w-20 bg-light"
    />
  )}

  {/* Candidate Pay Hours */}
  <Form.Control
    disabled
    value={attendanceDays.reduce((sum, day) => sum + (parseFloat(day.candidatePayHours) || 0), 0).toFixed(2)}
    className="w-20 bg-light"
  />
</div>

          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setAttendanceModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={markAttendance}>
            Save Attendance
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Monthly Attendance Modal */}
      <Modal
        show={monthlyModal}
        onHide={() => setMonthlyModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Monthly Attendance</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-wrap">{renderMonthlyView()}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMonthlyModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Submit Attendance Modal */}
      <Modal
        show={submitAttendanceModal}
        onHide={() => setSubmitAttendanceModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {currentCandidate?.invoiceNo
              ? "View Attendance"
              : "Submit Attendance"}
          </Modal.Title>
        </Modal.Header>
        <div className="list-group">
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th>Date</th>
                <th>Day</th>
                <th>Status</th>
                <th>Normal<br/>Hours</th>
                <th>Candidate<br/>Pay<br/>Hours</th>
                <th>Pay<br/>Amount</th>
                <th>Charge<br/>Amount</th>
                {overTimePayRate?.length > 0 && <th>Over<br/>Time<br/>Hours</th>}
                {overTimePayRate?.length > 0 && <th>Over<br/>Time<br/>Pay Amount</th>}
                {overTimePayRate?.length > 0 && <th>Over<br/>Time<br/>Charge Amount</th>}
                {bankHolidayOvertimePayRate?.length > 0 && <th>Bank Holiday<br/>OT Hours</th>}
                {bankHolidayOvertimePayRate?.length > 0 && <th>Bank Holiday<br/>OT Pay</th>}
                {bankHolidayOvertimePayRate?.length > 0 && <th>Bank Holiday<br/>OT Charge</th>}
                {nightRatePayRate?.length > 0 && <th>Night Rate<br/>Hours</th>}
                {nightRatePayRate?.length > 0 && <th>Night Rate<br/>Pay</th>}
                {nightRatePayRate?.length > 0 && <th>Night Rate<br/>Charge</th>}
              </tr>
            </thead>
            <tbody>
              {attendanceDays
                .slice()
                .sort((a, b) => new Date(a.jobDate) - new Date(b.jobDate))
                .map((day, idx) => {
                  if (!day.status) {
                    return null;
                  }
                  const dayName = new Date(day.jobDate).toLocaleDateString(
                    "en-GB",
                    {
                      weekday: "long",
                    }
                  );
                  const formattedDate = dayjs(day.jobDate).format("DD/MM/YYYY");

                  return (
                    <tr key={idx}>
                      <td>{formattedDate}</td>
                      <td>{dayName}</td>
                      <td>
                      {day.status}
                      </td>
                      <td>
                        {day.hours || 0}
                      </td>
                      <td>
                        {day.candidatePayHours || 0}
                      </td>
                      <td>
                      {day.candidatePayHours>0?(getPayRate() * (day.candidatePayHours || 0)):(getPayRate() * (day.hours || 0)).toFixed(2)}
                      </td>
                      <td>
                      {((getChargeRateRate() * (day.hours || 0))).toFixed(2)}
                      </td>
                      {overTimePayRate?.length > 0 && <td>
                        {day.overTimeHours || 0}
                      </td>}
                      {overTimePayRate?.length > 0 && <td>{((getOverTimePayRate() * (day.overTimeHours || 0))).toFixed(2)}</td>}
                      
                      {overTimePayRate?.length > 0 && <td>{((getOverTimeChargeRateRate() * (day.overTimeHours || 0))).toFixed(2)} </td>}
                      
                      {bankHolidayOvertimePayRate?.length > 0 && <td>{day.bankHolidayOverTimeHours || 0}</td>}
                      {bankHolidayOvertimePayRate?.length > 0 && <td>{((getBankHolidayOvertimePayRate() * (day.bankHolidayOverTimeHours || 0))).toFixed(2)}</td>}
                      {bankHolidayOvertimePayRate?.length > 0 && <td>{((getBankHolidayOvertimeChargeRate() * (day.bankHolidayOverTimeHours || 0))).toFixed(2)}</td>}
                      {nightRatePayRate?.length > 0 && <td>{day.nightRateHours || 0}</td>}
                      {nightRatePayRate?.length > 0 && <td>{((getNightRatePayRate() * (day.nightRateHours || 0))).toFixed(2)}</td>}
                      {nightRatePayRate?.length > 0 && <td>{((getNightRateChargeRate() * (day.nightRateHours || 0))).toFixed(2)}</td>}
                    </tr>
                  );
                })}
                {/* Totals Row */}
                <tr className="table-active font-weight-bold">
                  <td colSpan="3" className="text-right">Totals:</td>
                  <td>
                    {attendanceDays.reduce(
                      (sum, day) => sum + parseFloat(day.hours || 0),
                      0
                    ).toFixed(2)}
                  </td>
                  <td>
                    {attendanceDays.reduce(
                      (sum, day) => sum + parseFloat(day.candidatePayHours || 0),
                      0
                    ).toFixed(2)}
                  </td>
                  <td>
                    {attendanceDays.reduce(
                      (sum, day) => sum + (day.candidatePayHours > 0 ? (getPayRate() * (day.candidatePayHours || 0)) : (getPayRate() * (day.hours || 0))),
                      0
                    ).toFixed(2)}
                  </td>
                  <td>
                    {attendanceDays.reduce(
                      (sum, day) => sum + (getChargeRateRate() * (day.hours || 0)),
                      0
                    ).toFixed(2)}
                  </td>
                  {overTimePayRate?.length > 0 && (
                    <>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + parseFloat(day.overTimeHours || 0),
                          0
                        ).toFixed(2)}
                      </td>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + (getOverTimePayRate() * (day.overTimeHours || 0)),
                          0
                        ).toFixed(2)}
                      </td>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + (getOverTimeChargeRateRate() * (day.overTimeHours || 0)),
                          0
                        ).toFixed(2)}
                      </td>
                    </>
                  )}
                  {bankHolidayOvertimePayRate?.length > 0 && (
                    <>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + parseFloat(day.bankHolidayOverTimeHours || 0),
                          0
                        ).toFixed(2)}
                      </td>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + (getBankHolidayOvertimePayRate() * (day.bankHolidayOverTimeHours || 0)),
                          0
                        ).toFixed(2)}
                      </td>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + (getBankHolidayOvertimeChargeRate() * (day.bankHolidayOverTimeHours || 0)),
                          0
                        ).toFixed(2)}
                      </td>
                    </>
                  )}
                  {nightRatePayRate?.length > 0 && (
                    <>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + parseFloat(day.nightRateHours || 0),
                          0
                        ).toFixed(2)}
                      </td>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + (getNightRatePayRate() * (day.nightRateHours || 0)),
                          0
                        ).toFixed(2)}
                      </td>
                      <td>
                        {attendanceDays.reduce(
                          (sum, day) => sum + (getNightRateChargeRate() * (day.nightRateHours || 0)),
                          0
                        ).toFixed(2)}
                      </td>
                    </>
                  )}
                </tr>
            </tbody>
          </Table>

          <div style={{ display: overTimePayRate?.length > 0 ? "" : "none"}} className="list-group-item d-flex justify-content-between align-items-center bg-light font-weight-bold">
            <div className="w-25">Total Over Time Pay:</div>
            <div className="w-25">
              Overtime Pay{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getOverTimePayRate() * (day.overTimeHours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Overtime Charge{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getOverTimeChargeRateRate() * (day.overTimeHours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Overtime Charge %{" "}
              <strong>
                {getOverTimePayRate() && getOverTimeChargeRateRate()
                  ? (
                      ((getOverTimeChargeRateRate() - getOverTimePayRate()) /
                      getOverTimeChargeRateRate()) *
                      100
                    ).toFixed(2) + "%"
                  : "0.00%"}
              </strong>
            </div>
          </div>
          
          <div style={{ display: bankHolidayOvertimePayRate?.length > 0 ? "" : "none"}} className="list-group-item d-flex justify-content-between align-items-center bg-light font-weight-bold">
            <div className="w-25">Total Bank Holiday OT:</div>
            <div className="w-25">
              Bank Holiday OT Pay{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getBankHolidayOvertimePayRate() * (day.bankHolidayOverTimeHours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Bank Holiday OT Charge{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getBankHolidayOvertimeChargeRate() * (day.bankHolidayOverTimeHours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Bank Holiday OT Charge %{" "}
              <strong>
                {getBankHolidayOvertimePayRate() && getBankHolidayOvertimeChargeRate()
                  ? (
                      ((getBankHolidayOvertimeChargeRate() - getBankHolidayOvertimePayRate()) /
                      getBankHolidayOvertimeChargeRate()) *
                      100
                    ).toFixed(2) + "%"
                  : "0.00%"}
              </strong>
            </div>
          </div>
          
          <div style={{ display: nightRatePayRate?.length > 0 ? "" : "none"}} className="list-group-item d-flex justify-content-between align-items-center bg-light font-weight-bold">
            <div className="w-25">Total Night Hours:</div>
            <div className="w-25">
              Night Hours Pay{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getNightRatePayRate() * (day.nightRateHours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Night Rate Charge{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getNightRateChargeRate() * (day.nightRateHours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Night Rate Charge %{" "}
              <strong>
                {getNightRatePayRate() && getNightRateChargeRate()
                  ? (
                      ((getNightRateChargeRate() - getNightRatePayRate()) /
                      getNightRateChargeRate()) *
                      100
                    ).toFixed(2) + "%"
                  : "0.00%"}
              </strong>
            </div>
          </div>
          
          <div className="list-group-item d-flex justify-content-between align-items-center bg-light font-weight-bold">
            <div className="w-25">Total Standard Pay:</div>
            <div className="w-25">
              Pay{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + (day.candidatePayHours>0?getPayRate() * (day.candidatePayHours || 0):getPayRate() * (day.hours || 0)),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Charge{" "}
              <strong>
                &#xa3;
                {attendanceDays.reduce(
                  (sum, day) => sum + getChargeRateRate() * (day.hours || 0),
                  0
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Charge %{" "}
              <strong>
                {getPayRate() && getChargeRateRate()
                  ? (
                      ((getChargeRateRate() - getPayRate()) /
                        getChargeRateRate()) *
                      100
                    ).toFixed(2) + "%"
                  : "0.00%"}
              </strong>
            </div>
          </div>
          
          {/* Grand Total Row */}
          <div className="list-group-item d-flex justify-content-between align-items-center bg-dark text-white font-weight-bold">
            <div className="w-25">GRAND TOTAL:</div>
            <div className="w-25">
              Total Pay{" "}
              <strong>
                &#xa3;
                {(
                  /* Standard Pay */
                  attendanceDays.reduce(
                    (sum, day) => sum + (day.candidatePayHours > 0 ? getPayRate() * (day.candidatePayHours || 0) : getPayRate() * (day.hours || 0)),
                    0
                  ) +
                  /* Overtime Pay */
                  (overTimePayRate?.length > 0 ? attendanceDays.reduce(
                    (sum, day) => sum + getOverTimePayRate() * (day.overTimeHours || 0),
                    0
                  ) : 0) +
                  /* Bank Holiday OT Pay */
                  (bankHolidayOvertimePayRate?.length > 0 ? attendanceDays.reduce(
                    (sum, day) => sum + getBankHolidayOvertimePayRate() * (day.bankHolidayOverTimeHours || 0),
                    0
                  ) : 0) +
                  /* Night Hours Pay */
                  (nightRatePayRate?.length > 0 ? attendanceDays.reduce(
                    (sum, day) => sum + getNightRatePayRate() * (day.nightRateHours || 0),
                    0
                  ) : 0)
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Total Charge{" "}
              <strong>
                &#xa3;
                {(
                  /* Standard Charge */
                  attendanceDays.reduce(
                    (sum, day) => sum + getChargeRateRate() * (day.hours || 0),
                    0
                  ) +
                  /* Overtime Charge */
                  (overTimePayRate?.length > 0 ? attendanceDays.reduce(
                    (sum, day) => sum + getOverTimeChargeRateRate() * (day.overTimeHours || 0),
                    0
                  ) : 0) +
                  /* Bank Holiday OT Charge */
                  (bankHolidayOvertimePayRate?.length > 0 ? attendanceDays.reduce(
                    (sum, day) => sum + getBankHolidayOvertimeChargeRate() * (day.bankHolidayOverTimeHours || 0),
                    0
                  ) : 0) +
                  /* Night Hours Charge */
                  (nightRatePayRate?.length > 0 ? attendanceDays.reduce(
                    (sum, day) => sum + getNightRateChargeRate() * (day.nightRateHours || 0),
                    0
                  ) : 0)
                ).toFixed(2)}
              </strong>
            </div>
            <div className="w-25">
              Overall Charge %{" "}
              <strong>
                {(() => {
                  const totalPay = 
                    attendanceDays.reduce(
                      (sum, day) => sum + (day.candidatePayHours > 0 ? getPayRate() * (day.candidatePayHours || 0) : getPayRate() * (day.hours || 0)),
                      0
                    ) +
                    (overTimePayRate?.length > 0 ? attendanceDays.reduce(
                      (sum, day) => sum + getOverTimePayRate() * (day.overTimeHours || 0),
                      0
                    ) : 0) +
                    (bankHolidayOvertimePayRate?.length > 0 ? attendanceDays.reduce(
                      (sum, day) => sum + getBankHolidayOvertimePayRate() * (day.bankHolidayOverTimeHours || 0),
                      0
                    ) : 0) +
                    (nightRatePayRate?.length > 0 ? attendanceDays.reduce(
                      (sum, day) => sum + getNightRatePayRate() * (day.nightRateHours || 0),
                      0
                    ) : 0);

                  const totalCharge = 
                    attendanceDays.reduce(
                      (sum, day) => sum + getChargeRateRate() * (day.hours || 0),
                      0
                    ) +
                    (overTimePayRate?.length > 0 ? attendanceDays.reduce(
                      (sum, day) => sum + getOverTimeChargeRateRate() * (day.overTimeHours || 0),
                      0
                    ) : 0) +
                    (bankHolidayOvertimePayRate?.length > 0 ? attendanceDays.reduce(
                      (sum, day) => sum + getBankHolidayOvertimeChargeRate() * (day.bankHolidayOverTimeHours || 0),
                      0
                    ) : 0) +
                    (nightRatePayRate?.length > 0 ? attendanceDays.reduce(
                      (sum, day) => sum + getNightRateChargeRate() * (day.nightRateHours || 0),
                      0
                    ) : 0);

                  return totalCharge > 0 
                    ? (((totalCharge - totalPay) / totalCharge) * 100).toFixed(2) + "%"
                    : "0.00%";
                })()}
              </strong>
            </div>
          </div>
        </div>
        <Modal.Body></Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setSubmitAttendanceModal(false)}
          >
            Cancel
          </Button>
          {!currentCandidate?.invoiceNo && (
            <Button variant="primary" onClick={submitAttendance}>
              Submit & Approve Attendance
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
    candidates: state.candidates.candidates || [],
    loggedInUser: getLoggedInUser(state),
  };
};

export default withRouter(connect(mapStateToProps)(RequirementCandidates));
